<div>
  <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
  <p-calendar #calendar [(ngModel)]="value" inputStyleClass="form-control" dateFormat="dd/mm/yy" [showIcon]="true" [showTime]="showTime"
    [minDate]="minDate" [maxDate]="maxDate" [disabledDates]="disabledDates" [disabledDays]="disabledDays" [locale]="pt" hourFormat="24"
    [readonlyInput]="readonlyInput" [disabled]="disabled" [inputId]="identifier"></p-calendar>
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵp.html